export const backtopMixin = {
  data() {
    return {
      isMobile: window.innerWidth <= 768,
    };
  },
  computed: {
    backtopTarget() {
      if (this.isMobile) {
        return ".main-view-container";
      }
      return ".detail-scrollbar .el-scrollbar__wrap";
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
